import Choices from 'choices.js';

const choicesClassNames = {
	containerOuter: ['choices'],
	containerInner: ['choices__inner'],
	input: ['choices__input'],
	inputCloned: ['choices__input_cloned'],
	list: ['choices__list'],
	listItems: ['choices__list_multiple'],
	listSingle: ['choices__list_single'],
	listDropdown: ['choices__list_dropdown'],
	item: ['choices__item'],
	itemSelectable: ['choices__item_selectable'],
	itemDisabled: ['choices__item_disabled'],
	itemChoice: ['choices__item_choice'],
	description: ['choices__description'],
	placeholder: ['choices__placeholder'],
	group: ['choices__group'],
	groupHeading: ['choices__heading'],
	button: ['choices__button'],
	activeState: ['is-active'],
	focusState: ['is-focused'],
	openState: ['is-open'],
	disabledState: ['is-disabled'],
	highlightedState: ['is-highlighted'],
	selectedState: ['is-selected'],
	flippedState: ['is-flipped'],
	loadingState: ['is-loading'],
	notice: ['choices__notice'],
	addChoice: ['choices__item_selectable', 'add-choice'],
	noResults: ['has-no-results'],
	noChoices: ['has-no-choices'],
}

// вызов для селектов с одним значением
const singleSelect = document.querySelectorAll('[data-select]');
singleSelect.forEach(select => {
	const placeholderText = select.getAttribute('data-placeholder');
	const choices = new Choices(select, {
		silent: false,
		items: [],
		choices: [],
		renderChoiceLimit: -1,
		maxItemCount: -1,
		closeDropdownOnSelect: 'auto',
		searchEnabled: false,
		position: 'auto',
		resetScrollPosition: true,
		shouldSort: false,
		shouldSortItems: false,
		placeholder: true,
		placeholderValue: placeholderText,
		labelId: '',
		noChoicesText: '',
		itemSelectText: '',
		classNames: choicesClassNames,
		removeItemButton: true,
	});
})

// вызов для селектов с множественным значением
const multipleSelect = document.querySelectorAll('[data-select-multiple]');
multipleSelect.forEach(select => {
	const placeholderText = select.getAttribute('data-placeholder');
	const choices = new Choices(select, {
		silent: false,
		items: [],
		choices: [],
		renderChoiceLimit: -1,
		maxItemCount: -1,
		closeDropdownOnSelect: false,
		singleModeForMultiSelect: false,
		removeItemButton: true,
		delimiter: ',',
		paste: true,
		searchEnabled: false,
		position: 'auto',
		resetScrollPosition: true,
		shouldSort: false,
		shouldSortItems: false,
		sorter: function(a, b) {
			return b.label.localeCompare(a.label);
		},
		placeholder: true,
		placeholderValue: placeholderText,
		searchPlaceholderValue: null,
		prependValue: null,
		appendValue: null,
		renderSelectedChoices: 'auto',
		noChoicesText: 'Пусто',
		itemSelectText: 'Пусто',
		noResultsText: 'Ничего не найдено',
		addItemText: (value) => {
			return `Press Enter to add <b>"${value}"</b>`;
		},
		removeItemIconText: () => `Удалить`,
		removeItemLabelText: (value) => `Удалить: ${value}`,
		valueComparer: (value1, value2) => {
			return value1 === value2;
		},
		classNames: choicesClassNames,
	});

// Функция для вычисления ширины текста
	const calculatePlaceholderWidth = (text) => {
		const tempSpan = document.createElement('span');
		tempSpan.style.visibility = 'hidden';
		tempSpan.style.position = 'absolute';
		tempSpan.style.whiteSpace = 'nowrap';
		tempSpan.style.font = 'inherit';
		tempSpan.textContent = text;
		document.body.appendChild(tempSpan);
		const width = tempSpan.offsetWidth;
		document.body.removeChild(tempSpan);
		return width;
	};

// Функция для обновления ширины инпута
	const updateInputWidth = (width) => {
		const input = select.closest('.choices').querySelector('.choices__input_cloned');
		const placeholderWidth = calculatePlaceholderWidth(placeholderText);
		input.style.width = `${placeholderWidth + 18}px`; // Устанавливаем ширину инлайнового стиля
		input.style.minWidth = `unset`;
		if (width) {
			input.style.width = `20px`;
		}
	};

// Функция для обновления placeholder
	const updatePlaceholder = () => {
		const input = select.closest('.choices').querySelector('.choices__input_cloned');
		if (choices.getValue(true).length > 0) {
			input.placeholder = '';
			select.setAttribute('data-placeholder', '');
			updateInputWidth(true);
		} else {
			input.placeholder = placeholderText;
			select.setAttribute('data-placeholder', placeholderText);
			updateInputWidth();
		}
	};

// Событие на добавление элемента
	select.addEventListener('addItem', () => {
		updatePlaceholder();
	});

// Событие на удаление элемента
	select.addEventListener('removeItem', () => {
		updatePlaceholder();
	});

// Инициализация placeholder при загрузке страницы
	updatePlaceholder();
})
